import * as v2 from './v2';
export function restrictedByEvents(group) {
    return v2.restrictedByEvents(group.settings.accessRestriction);
}
export function restrictedByAdmin(group) {
    var _a;
    return v2.restrictedByAdmin((_a = group.settings) === null || _a === void 0 ? void 0 : _a.accessRestriction);
}
//# sourceMappingURL=index.js.map